const pageNameKey = "supportChat";

export const supportChatEn = {
  [pageNameKey]: {
    noFirmwareInformation: "No firmware information",
    saveButton: "Save",
    sourceLabel: "Machine",
    sourcePlaceholder: "Select a machine",
    noSourcesFound: "No machines found",
    subtitle: "Things Support",
    getStartedQuestionText: "Send a message to the support team.",
    issueDetails: "Issue Details",
    inputMessage: "Enter message...",
    downloadAttachmentError:
      "Failed to download attachment. Please try again later.",
    downloadEmpty: "Download URL is empty.",
  },
};

export const supportChatPtBr = {
  [pageNameKey]: {
    noFirmwareInformation: "Nenhuma informação de firmware",
    saveButton: "Salvar",
    sourceLabel: "Máquina",
    sourcePlaceholder: "Selecione uma máquina",
    noSourcesFound: "Nenhuma máquina encontrada",
    subtitle: "Suporte para Coisas",
    getStartedQuestionText: "Envie uma mensagem para a equipe de suporte.",
    issueDetails: "Detalhes do problema",
    inputMessage: "Digite uma mensagem...",
    downloadAttachmentError:
      "Falha ao baixar o anexo. Tente novamente mais tarde.",
    downloadEmpty: "A URL de download está vazia.",
  },
};

export const supportChatDe = {
  [pageNameKey]: {
    noFirmwareInformation: "Keine Firmware-Informationen",
    saveButton: "Speichern",
    sourceLabel: "Maschine",
    sourcePlaceholder: "Maschine auswählen",
    noSourcesFound: "Keine Maschinen gefunden",
    subtitle: "Things Support",
    getStartedQuestionText: "Senden Sie eine Nachricht an das Support-Team.",
    issueDetails: "Problemdetails",
    inputMessage: "Nachricht eingeben...",
    downloadAttachmentError:
      "Fehler beim Herunterladen des Anhangs. Bitte versuchen Sie es später erneut.",
    downloadEmpty: "Die Download-URL ist leer.",
  },
};

export const supportChatZhHans = {
  [pageNameKey]: {
    noFirmwareInformation: "暂无固件信息",
    saveButton: "保存",
    sourceLabel: "机器",
    sourcePlaceholder: "选择机器",
    noSourcesFound: "未找到机器",
    subtitle: "Things 技术支持",
    getStartedQuestionText: "向支持团队发送消息。",
    issueDetails: "问题详情",
    inputMessage: "输入消息...",
    downloadAttachmentError: "下载附件失败。请稍后再试。",
    downloadEmpty: "下载 URL 为空。",
  },
};

export const supportChatIt = {
  [pageNameKey]: {
    noFirmwareInformation: "Nessuna informazione sul firmware",
    saveButton: "Salva",
    sourceLabel: "Macchina",
    sourcePlaceholder: "Seleziona una macchina",
    noSourcesFound: "Nessuna macchina trovata",
    subtitle: "Supporto Things",
    getStartedQuestionText: "Invia un messaggio al team di supporto.",
    issueDetails: "Dettagli del problema",
    inputMessage: "Inserisci un messaggio...",
    downloadAttachmentError:
      "Impossibile scaricare l'allegato. Riprova più tardi.",
    downloadEmpty: "L'URL di download è vuoto.",
  },
};

export const supportChatEs = {
  [pageNameKey]: {
    noFirmwareInformation: "Sin información de firmware",
    saveButton: "Guardar",
    sourceLabel: "Máquina",
    sourcePlaceholder: "Selecciona una máquina",
    noSourcesFound: "No se encontraron máquinas",
    subtitle: "Soporte de Things",
    getStartedQuestionText: "Envía un mensaje al equipo de soporte.",
    issueDetails: "Detalles del problema",
    inputMessage: "Escribe un mensaje...",
    downloadAttachmentError:
      "No se pudo descargar el archivo adjunto. Por favor, inténtalo de nuevo más tarde.",
    downloadEmpty: "La descarga URL está vacía.",
  },
};

export const supportChatNl = {
  [pageNameKey]: {
    noFirmwareInformation: "Geen firmware-informatie",
    saveButton: "Opslaan",
    sourceLabel: "Machine",
    sourcePlaceholder: "Selecteer een machine",
    noSourcesFound: "Geen machines gevonden",
    downloadAttachmentError:
      "Fout bij het downloaden van de bijlage. Probeer het later opnieuw.",
    downloadEmpty: "Download-URL is leeg.",
    getStartedQuestionText: "Stuur een bericht naar het supportteam.",
    inputMessage: "Voer een bericht in...",
    issueDetails: "Probleemdetails",
    subtitle: "Things Support",
  },
};

export const supportChatTr = {
  [pageNameKey]: {
    noFirmwareInformation: "Aygıt yazılımı bilgisi yok",
    saveButton: "Kaydet",
    sourceLabel: "Makine",
    sourcePlaceholder: "Makine seçin",
    noSourcesFound: "Makine bulunamadı",
    downloadAttachmentError:
      "Ek indirilemedi. Lütfen daha sonra tekrar deneyin.",
    downloadEmpty: "İndirme URL'si boş.",
    getStartedQuestionText: "Destek ekibine bir mesaj gönderin.",
    inputMessage: "Mesajı girin...",
    issueDetails: "Sorun Ayrıntıları",
    subtitle: "Şeyler Desteği",
  },
};
